import React from 'react'

// Small icon button pinned to the top-right corner of a feed card
const DeleteButton = ({ onClick, label = 'Delete' }) => {
  return (
    <button
      type="button"
      className="btn btn-icon bl-card-delete"
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <ion-icon name="trash-outline" aria-hidden="true"></ion-icon>
    </button>
  )
}

export default DeleteButton
